import { LinkId } from '../../../common/AnalyticsContext/LinkId';
import { useSearchFilters } from '../../../common/components/SearchHeader/filters/useSearchFilters';
import { SPECIALTY_GENERAL_PRACTICE } from '../../../common/components/SearchHeader/types/FilterChoice';
import { FilterPill } from '../FilterPill/FilterPill';
import { useOverlay } from '../overlay/OverlayContext';

export const BulkBillingFilter = () => {
  const [filters, setFilters] = useSearchFilters();
  const { clear } = useOverlay();

  const handleClick = () => {
    const { topic } = filters;

    setFilters({
      ...filters,
      topic: topic?.bulkBillingGp
        ? { specialist: SPECIALTY_GENERAL_PRACTICE }
        : { bulkBillingGp: true },
    });

    clear();
  };

  return (
    <FilterPill
      trackingId={LinkId.FILTER_BY_BULK_BILLING_BUTTON}
      onClick={handleClick}
      hasValue={filters.topic?.bulkBillingGp}
    >
      Bulk billing
    </FilterPill>
  );
};
